import { initializeApp, getApps } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";

const uatFirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: "castrol-elevate.firebaseapp.com",
  projectId: "castrol-elevate",
  storageBucket: "castrol-elevate.firebasestorage.app",
  messagingSenderId: "935245456937",
  appId: "1:935245456937:web:138f7d96f98b4a150b1e38",
  measurementId: "G-SM45VV5YD3",
};

const prodFirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY_PRODUCTION,
  authDomain: "castrol-elevate-91a9b.firebaseapp.com",
  projectId: "castrol-elevate-91a9b",
  storageBucket: "castrol-elevate-91a9b.firebasestorage.app",
  messagingSenderId: "997461947858",
  appId: "1:997461947858:web:2c0eca1c4187e6b7d2c40b",
  measurementId: "G-62JZLXRL55",
};

const firebaseConfig =
  process.env.REACT_APP_ENV === "production"
    ? prodFirebaseConfig
    : uatFirebaseConfig;
    //console.log('fire',firebaseConfig)

if (!firebaseConfig.apiKey) {
  throw new Error("Missing REACT_APP_FIREBASE_API_KEY environment variable");
}

// Prevent re-initialization (important in React StrictMode / HMR)
const app =
  getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];

// Analytics is async — not available in SSR or some browsers (e.g. Firefox private mode)
export const analyticsPromise = isSupported().then((yes) =>
  yes ? getAnalytics(app) : null
);

export default app;
